import { Directive, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ColumnOrderDataDirective } from './column-order-data-source.directive';

@Directive({
    selector: '[re-column-order-property]',
    standalone: false
})
export class ColumnOrderDirective implements OnInit {

  private element: HTMLElement;

  constructor(private el: ElementRef, private dataDirective: ColumnOrderDataDirective) {
    this.element = <HTMLElement>el.nativeElement;

    this.element.classList.add("sorting");
    let table: HTMLTableElement = this.element.closest("table");

    //table.classList.add("dataTable");
    this.element.addEventListener("click", () => this.clicked());
    this.dataDirective.registreOrderDirective(this);
  }
  ngOnInit(): void {

  }
  clicked() {
    let sortClass = "";
    let sort = "";
    if (this.element.classList.contains("sorting_asc")) {
      sortClass = "sorting_desc";
      sort = "desc";
    }
    else if (this.element.classList.contains("sorting_desc")) {
      sortClass = "sorting_asc";
      sort = "asc";
    }

    if (!sortClass) {
      sortClass = "sorting_asc";
      sort = "asc";
    }

    this.setIcons(sort);
    this.order();
  }

  @Output("re-column-order-clicked")
  ReportSort = new EventEmitter<string>();


  private _defaultSort: ("asc" | "desc");
  public get defaultSort(): ("asc" | "desc") {
    return this._defaultSort;
  }
  @Input("re-column-order-default")
  public set defaultSort(value: ("asc" | "desc")) {
    this._defaultSort = value;

    this.setIcons(value);

  }



  private setIcons(order) {
    let table: HTMLTableElement = this.element.closest("table");
    let headers = table.querySelectorAll("th.sorting");
    headers.forEach((cell) => {
      cell.classList.remove("sorting_asc");
      cell.classList.remove("sorting_desc");
    })


    if (order) {
      this.element.classList.add("sorting_" + order);
    }
  }
  public order(order = null) {
    if (!this.dataDirective.data || !this.column)
      return;


    let currentOrder = order;
    if (!currentOrder) {
      if (this.element.classList.contains("sorting_asc"))
        currentOrder = "asc";
      if (this.element.classList.contains("sorting_desc"))
        currentOrder = "desc";
    }






    this.ReportSort.emit(currentOrder);
    if (currentOrder) {
      let newData = this.dataDirective.data.orderBy(this.column, currentOrder);
      //this._data = newData;
      for (let i = 0; i < newData.length; i++) {
        this.dataDirective.data[i] = newData[i];
      }
      this.dataDirective.dataChange.emit(this.dataDirective.data);
      //this.dataChange.emit(newData);
    }

  }




  @Input("re-column-order-property")
  column: string;


}

